import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-prompt',
    templateUrl: './prompt.component.html',
    styleUrls: ['./prompt.component.scss']
})
export class PromptComponent implements OnInit {

    public form: FormGroup = this.fb.group({});
    constructor(
        public dialogRef: MatDialogRef<PromptComponent>,
        public fb: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    buildForm() {
        this.form = this.fb.group({
            value: new FormControl(this.data.value,[Validators.required]),
        });
    }

    ngOnInit() {
        this.buildForm()
    }

    close() {
        this.dialogRef.close();
    }

    validate() {
        this.dialogRef.close(this.form.value.value);
    }

}
